import { RubyPlayGameClientWrapper } from '@gongxigames/framework/integrations/rubyplay/RubyPlayGameClientWrapper';
import { RubyPlayGameClientWrapperSettings } from '@gongxigames/framework/integrations/rubyplay/RubyPlayGameClientWrapperSettings';
import { ResponseBody, ServerResponseData } from '@gongxigames/framework/integrations/rubyplay/types';
import { LogicEvents } from '@gongxigames/framework/slot';
import { Action } from 'com/gongxigames/math/core/game/enums/Action';
import {strictUiEmitter} from '@gongxigames/framework/slotV2/globals';

export class ModoGameClientWrapper extends RubyPlayGameClientWrapper {
    public static NAME = 'modo';
    public pointsBalance = 0;

    protected setupEvents(): void {
        super.setupEvents();
        this._eventManager.on('General.Game.INITIALIZED', this.onGameInitialized.bind(this), this);
        this._eventManager.on('General.UI.BALANCE.UPDATED', this.onBalanceUpdated.bind(this), this);
    }

    private onGameInitialized(): void {
        this._eventManager.emit(LogicEvents.POINTS_BALANCE_UPDATED, this.pointsBalance);
        strictUiEmitter.emit('LogicEvents.POINTS_BALANCE_UPDATED', this.pointsBalance);
    }

    private onPointsBalanceUpdate(body: ResponseBody): void {
        if (body.data?.player?.bonusBalance) {
            this.pointsBalance = body.data.player.bonusBalance;
        }
    }

    private onBalanceUpdated(): void {
        this._eventManager.emit(LogicEvents.POINTS_BALANCE_UPDATED, this.pointsBalance);
        strictUiEmitter.emit('LogicEvents.POINTS_BALANCE_UPDATED', this.pointsBalance);
    }

    protected onGameServerActionResponse(body: ResponseBody, action: Action): void {
        this.onPointsBalanceUpdate(body);
        super.onGameServerActionResponse(body, action);
    }

    protected updateBalance(body: ResponseBody): void {
        this.onPointsBalanceUpdate(body);
        super.updateBalance(body);
    }

    protected configureCurrencyFormatter(data: ServerResponseData): void {
        super.configureCurrencyFormatter(data);
        const settings = this.getSettings<RubyPlayGameClientWrapperSettings>();
        const currencyCode = settings.get('currency');
        const fractionSize = settings.get('subunit');
        const localeCode = settings.get('lang');

        if (settings.get('isPointsCurrencyEnabled')) {
            const secondaryCurrencyCode = 'POINT';
            const pointsCurrencyConfiguration = {
                fractionSize: 2,
                name: 'Point',
                symbol: {
                    grapheme: '',
                    rtl: false,
                    template: '$1'
                },
                uniqSymbol: {
                    grapheme: '',
                    rtl: false,
                    template: '$1'
                }
            };

            this._currencyFormatter.setCurrencyData(secondaryCurrencyCode, pointsCurrencyConfiguration);

            this._currencyFormatter.setParameters({
                currencyCode: secondaryCurrencyCode,
                fractionSize,
                localeCode,
                secondaryCurrencyCode: currencyCode
            });
        }
    }
}
